module.exports = __webpack_public_path__ + "static/media/i-dont-work-you-dig.1184d011.jpg";